<template lang="pug">
div(
    v-bind="columnEditable"
    :class="columnOrder"
)
    template(v-for="widget in data.widgets")
        slot(:widget="widget" :columnSpaceLeft="columnSpaceLeft")
</template>

<script>
import { bindStoryblokBridgeData, getScreenClassPrefix } from '../../../helpers'

export default {
    name: 'Column',
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        layouts: {
            type: Object,
            default() {
                return {}
            },
        },
        columnIndex: {
            type: Number,
            default: 0,
        },
        spaceLeft: {
            type: Object,
            default() {
                return {}
            },
        },
        mobileColumnLayout: {
            type: String,
            default: '',
        },
        tabletColumnLayout: {
            type: String,
            default: '',
        },
        desktopColumnLayout: {
            type: String,
            default: '',
        },
    },
    computed: {
        columnEditable() {
            return bindStoryblokBridgeData(this.data)
        },
        columnOrder() {
            return getScreenClassPrefix(
                this.generateColumnOrder(this.mobileColumnLayout),
                this.generateColumnOrder(this.tabletColumnLayout),
                this.generateColumnOrder(this.desktopColumnLayout)
            )
        },
        columnSpaceLeft() {
            // Figure out what the value of each breakpoint is.
            const mobileLayout = this.mobileColumnLayout
            const tabletLayout =
                this.tabletColumnLayout !== 'INHERIT' ? this.tabletColumnLayout : mobileLayout
            const desktopLayout =
                this.desktopColumnLayout !== 'INHERIT' ? this.desktopColumnLayout : tabletLayout

            return {
                mobile: this.calculateSpaceLeft(this.spaceLeft.mobile, mobileLayout),
                tablet: this.calculateSpaceLeft(this.spaceLeft.tablet, tabletLayout),
                desktop: this.calculateSpaceLeft(this.spaceLeft.desktop, desktopLayout),
            }
        },
    },
    methods: {
        generateColumnOrder(layout) {
            /**
             * Tailwind Order Whitelist
             *
             * Because we are dynamically creating the class names to reduce the JS complexity
             * we have to list these classes out so they don't get purged during the build process
             *
             * order-none md:order-none lg:order-none
             * order-first md:order-first lg:order-first
             *
             */

            if (layout === 'INHERIT') return ''
            if (layout === '2_COL_REVERSE' && this.columnIndex > 0) return 'order-first'
            return 'order-none'
        },
        calculateSpaceLeft(spaceLeft, layout) {
            let columnPercent = 0

            const selectedLayout = this.layouts[layout]?.percent

            if (!selectedLayout) return spaceLeft

            if (Array.isArray(selectedLayout)) {
                const columnValue = this.columnIndex % selectedLayout.length
                columnPercent = selectedLayout[columnValue]
            } else {
                columnPercent = selectedLayout
            }

            return Math.round(spaceLeft * (columnPercent / 100))
        },
    },
}
</script>
